import { render, staticRenderFns } from "./forgetPw.vue?vue&type=template&id=1784ae10&scoped=true&"
import script from "./forgetPw.vue?vue&type=script&lang=js&"
export * from "./forgetPw.vue?vue&type=script&lang=js&"
import style0 from "./forgetPw.vue?vue&type=style&index=0&id=1784ae10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1784ae10",
  null
  
)

export default component.exports